@if (visible) {
  <header [ngClass]="cssClassName">
    <pub-logo-wrapper></pub-logo-wrapper>
    <div class="header-nav-container">
      <div class="header-nav">
        <pub-language-switcher></pub-language-switcher>
        @if (showFeedbackLink) {
          <mat-icon (click)="toggleFeedbackMode()" class="feedback-link" [class.feedback-active]="feedbackMode.isActive"
                    [matTooltip]="feedbackLabel">mail
          </mat-icon>
        }
        @if (showAdminLink) {
          <!--        <pub-configuration-selector [visible]="showAdminLink && showLayoutSelector"></pub-configuration-selector>-->
          <a [routerLink]="['/admin/home']">{{ administrationLabel }}</a>
        }
        <a href="javascript:void(0)" (click)="openAboutDialog()">{{ aboutLabel }}</a>
        @if (showLogoutLink) {
          <a href="javascript:void(0)" (click)="externalLogout()">{{ signOutLabel }}</a>
        }
      </div>
    </div>
  </header>
}
